import { useQuery } from "@blitzjs/rpc"
import getCurrentUser from "src/users/queries/getCurrentUser"

export const useCurrentUser = () => {
  const [user] = useQuery(getCurrentUser, null, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
  return user
}
